<template>
  <div class="app-mnp-out-status">
    <div class="headline">
      <slot name="txtHeadline">Portierungsrelevante Daten</slot>
    </div>
    <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
      <div class="content" v-if="mnpOutStatus !== null">
        <div class="description">
          <slot name="txtBeforeContent">
            Diese Daten werden vom aufnehmenden Diensteanbieter in der hier vorliegenden Form
            benötigt, um Ihre Daten wiederum bei uns, dem aktuellen Diensteanbieter, zu erfragen.
          </slot>
        </div>
        <div class="content-data">
          <b-row class="request-date">
            <b-col class="label">
              <slot name="lblRequestDate">Datum:</slot>
            </b-col>
            <b-col class="value">
            <div v-if="getMnpOutStatusEntries.requestDate !== null">
                {{ dateTimeFormatter(getMnpOutStatusEntries.requestDate) }}
            </div>
            </b-col>
          </b-row>
          <b-row class="customer-type">
            <b-col class="label">
              <slot name="lblCustomerType">Kundentyp:</slot>
            </b-col>
            <b-col class="value">
              {{ getMnpOutStatusEntries.customerType }}
            </b-col>
          </b-row>
          <b-row class="last-name">
            <b-col class="label">
              <slot name="lblLastName">Nachname:</slot>
            </b-col>
            <b-col class="value">
              {{ getMnpOutStatusEntries.lastName }}
            </b-col>
          </b-row>
          <b-row class="first-name">
            <b-col class="label">
              <slot name="lblFirstName">Vorname:</slot>
            </b-col>
            <b-col class="value">
              {{ getMnpOutStatusEntries.firstName }}
            </b-col>
          </b-row>
          <b-row class="birthdate">
            <b-col class="label">
              <slot name="lblBirthDate">Geburtstag:</slot>
            </b-col>
            <b-col class="value">
              <div v-if="getMnpOutStatusEntries.birthdate !== null">
                {{ dateTimeFormatter(getMnpOutStatusEntries.birthdate) }}
              </div>
            </b-col>
          </b-row>
          <b-row class="msisdn">
            <b-col class="label">
              <slot name="lblMsisdn">Zu portierende Rufnummer:</slot>
            </b-col>
            <b-col class="value">
              {{ getMnpOutStatusEntries.msisdn }}
            </b-col>
          </b-row>
          <b-row class="service-provider-code">
            <b-col class="label">
              <slot name="lblServiceProviderCode">Providererkennung:</slot>
            </b-col>
            <b-col class="value">
              {{ getMnpOutStatusEntries.serviceProviderCode }}
            </b-col>
          </b-row>
          <b-row class="termination-date">
            <b-col class="label">
              <slot name="lblTerminationDate">Kündigungsdatum:</slot>
            </b-col>
            <b-col class="value">
              <div v-if="getMnpOutStatusEntries.terminationDate">
                {{ dateTimeFormatter(getMnpOutStatusEntries.terminationDate) }}
              </div>
            </b-col>
          </b-row>
          <b-row class="opt-in-validity">
            <b-col class="label">
              <slot name="lblOptInValidity">Gültigkeitsdatum OPT-in:</slot>
            </b-col>
            <b-col class="value">
              <div v-if="getMnpOutStatusEntries.optInValidity !== null">
                {{ dateTimeFormatter(getMnpOutStatusEntries.optInValidity) }}
              </div>
            </b-col>
          </b-row>
        </div>
        <Stepper
          :show-prev="false"
          :loading-next="loadingPdf"
          @next="downloadPdf()"
        >
          <template #btnNext>
            <slot name="btnNext">Als PDF herunterladen</slot>
          </template>
        </Stepper>
      </div>
      <div class="content" v-if="mnpOutStatus == null && !loading">
        <slot name="txtNoDataContent">
          Es sind keine portierungsrelevanten Daten vorhanden.
        </slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import Stepper from '@/components/generic/Stepper.vue'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import { splitError } from '@/helper/splitError'
import FileSaver from 'file-saver'

export default {
  name: 'ShowMnpOutStatus',
  components: { Stepper },
  mixins: [
    transaction('mnpOutStatus')
  ],
  computed: {
    getMnpOutStatusEntries () {
      return this.mnpOutStatus
    }
  },
  data () {
    return {
      mnpOutStatus: null,
      loading: false,
      loadingPdf: false
    }
  },
  methods: {
    dateTimeFormatter (date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    },
    downloadPdf: function () {
      this.loadingPdf = true
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient.query({
        query: gql`query mnpOutStatus {
            mnpOutStatusPdf {
              contentType
              document
            }
        }`
      }).then(response => {
        this.loadingPdf = false
        if (response.data.mnpOutStatusPdf !== null) {
          const decodedDocumentPdf = Uint8Array.from(atob(response.data.mnpOutStatusPdf.document), c => c.charCodeAt(0))
          const file = new Blob([decodedDocumentPdf], { type: response.data.mnpOutStatusPdf.contentType })
          FileSaver.saveAs(file, 'mnp-status.pdf')
        } else me.$store.commit('addError', 'Die PDF konnte nicht heruntergeladen werden.')
      }).catch((error) => {
        this.loadingCSV = false

        splitError(error).forEach(e => me.$store.commit('addError', e))
      })
    }
  },
  apollo: {
    mnpOutStatus: function () {
      this.loading = true
      return wrapQuery(
        gql`query mnpOutStatus {
          mnpOutStatus {
            birthdate,
            customerType,
            firstName,
            lastName,
            msisdn,
            optInValidity,
            portingDate,
            requestDate,
            serviceProviderCode,
            terminationDate
          }
        }`, this, 'mnpOutStatus', {}, () => {
          this.loading = false
        },
        {
          fetchPolicy: 'cache-first'
        },
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>
